import useSWRImmutable from 'swr';
import type { AxiosError } from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetRuleOperations = ():{ operations: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  // stubbed as harded coded for now
  const fetcher = () => ([
    {
      value: '==',
      label: '==',
    },
    {
      value: '!=',
      label: '!=',
    },
    {
      value: '>',
      label: '>',
    },
    {
      value: '<',
      label: '<',
    },
    {
      value: '>=',
      label: '>=',
    },
    {
      value: '<=',
      label: '<=',
    },
    {
      value: 'contains',
      label: 'Contains',
    },
    {
      value: 'does not contain',
      label: 'Does not contain',
    },
  ]);

  const { data, error } = useSWRImmutable<ILabelValuePair[], AxiosError>('/pricing/getOperations',
    () => fetcher());

  return {
    operations: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetRuleOperations;
